/** Включить UI и действия модерации профилей. По умолчанию выключено. */
export var isProfileModerationEnabled = process.env.REACT_APP_PROFILE_MODERATION_ENABLED === 'true' ||
    process.env.REACT_APP_PROFILE_MODERATION_ENABLED === '1';
